<template>
  <div id="app">
    <!-- Header Stats -->
    <top-nav v-if="!isRoutePublic($route)"></top-nav>
    <!-- Content -->
    <div class="columns" :class="{'is-marginless' : isLoggedIn && !isRoutePublic($route) }">
      <!-- Menu -->
      <aside v-if="isLoggedIn &&!$route.path.includes('login') && !$route.path.includes('resetpassword') && !$route.path.includes('download')" class="column is-2 aside hero is-fullheight is-hidden-mobile">
        <div>
          <div class="main">
            <menu-list :role="loggedUser.role"></menu-list>
          </div>
        </div>
      </aside>
      <!-- Routes content -->
      <main class="column" :class="{'is-10' : isLoggedIn && !isRoutePublic($route) }">
        <transition name="component-fade" mode="out-in">
          <!-- Using ":key" to force the component to be re-created of re-used.
               This is needed for Upsert routes/components.
               Resource: https://goo.gl/Jin7nb
          -->
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </main>
    </div>
    <!-- Footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import topNav from '@/components/BaseTopNav'
import menuList from '@/components/BaseMenuList'
import footerBar from '@/components/FooterLogo'

export default {
  name: 'App',
  components: {
    topNav,
    menuList,
    footerBar
  },
  computed: {
    ...mapGetters('auth', ['loggedUser', 'isLoggedIn', 'isRoutePublic'])
  }
}
</script>

<style lang="sass">
@import './assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue